import { render, staticRenderFns } from "./SwitchHighRating.vue?vue&type=template&id=3968052a&"
import script from "./SwitchHighRating.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SwitchHighRating.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3968052a')) {
      api.createRecord('3968052a', component.options)
    } else {
      api.reload('3968052a', component.options)
    }
    module.hot.accept("./SwitchHighRating.vue?vue&type=template&id=3968052a&", function () {
      api.rerender('3968052a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/lpu/components/LpuFilters/components/SwitchHighRating/SwitchHighRating.vue"
export default component.exports